<!-- Documentation Sources -->
<div class="content bg-grey pb-5">
  <div class="pt-5 text-center">
    <h4 class="text-grey">EXAMPLES OF DOCUMENTATION SOURCES</h4>
  </div>
  <div class="pb-5">
    <div class="row card-padding pb-5">
      <div class="column">
        <div class="card bg-white">
          <img src="./../../assets/images/react.jpg" class="card-img-top" alt="...">
          <div class="card-body">
            <h5 class="card-title">React</h5>
            <a href="https://reactjs.org/docs/getting-started.html" class="btn btn-primary">Go to React Documentation</a>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="card bg-white">
          <img src="./../../assets/images/audacity.jpg" class="card-img-top" alt="...">
          <div class="card-body">
            <h5 class="card-title">Audacity</h5>
            <a href="https://support.audacityteam.org/" class="btn btn-primary">Go to Audacity Documentation</a>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="card bg-white">
          <img src="./../../assets/images/java.jpg" class="card-img-top" alt="...">
          <div class="card-body">
            <h5 class="card-title">Java</h5>
            <a href="https://docs.oracle.com/en/java/" class="btn btn-primary">Go to Java Documentation</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Tools -->
<div class="content bg-black pt-5 pb-5">
  <div class="pt-5 text-center">
    <h4 class="text-grey">USEFUL TOOLS</h4>
  </div>
  <div class="pb-5">
    <div class="row card-padding pb-5">
      <div class="column">
        <div class="card bg-white">
          <img src="./../../assets/images/google.jpg" class="card-img-top" alt="...">
          <div class="card-body">
            <h5 class="card-title">Google</h5>
            <a href="https://www.google.com/" class="btn btn-primary">Link to Google</a>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="card bg-white">
          <img src="./../../assets/images/notion.jpg" class="card-img-top" alt="...">
          <div class="card-body">
            <h5 class="card-title">Notion</h5>
            <a href="https://www.notion.so/" class="btn btn-primary">Link to Notion</a>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="card bg-white">
          <img src="./../../assets/images/vscode.jpg" class="card-img-top" alt="...">
          <div class="card-body">
            <h5 class="card-title">Visual Studio Code</h5>
            <a href="https://code.visualstudio.com/download" class="btn btn-primary">Link to Visual Studio Code</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Example Projects -->
<div class="content bg-grey pt-5 pb-5">
  <div class="pt-5 text-center">
    <h4 class="text-grey">EXAMPLE PROJECTS</h4>
  </div>
  <div class="pb-5">
    <div class="row card-padding pb-5">
      <div class="column">
        <div class="card bg-white">
          <img src="./../../assets/images/project-1.PNG" class="card-img-top" alt="...">
          <div class="card-body">
            <h5 class="card-title">Top-Down 2D Pixel Game</h5>
            <a href="https://github.com/vondreii/ice-capades" class="btn btn-primary">Read More</a>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="card bg-white">
          <img src="./../../assets/images/project-2.jpg" class="card-img-top" alt="...">
          <div class="card-body">
            <h5 class="card-title">Netflix Clone</h5>
            <a href="https://github.com/vondreii/js-netflix-clone" class="btn btn-primary">Read More</a>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="card bg-white">
          <img src="./../../assets/images/project-3.jpg" class="card-img-top" alt="...">
          <div class="card-body">
            <h5 class="card-title">Calculator Desktop App</h5>
            <a href="https://github.com/vondreii/calculator" class="btn btn-primary">Read More</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>